import React, { useEffect, useState } from "react";
import { API_ROUTES } from "../../../utils/constants";
import Nulls from "../Nulls";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import BreadcrumTop from "../BreadcrumTop";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../../utils/getToken";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import Spinner from "../../../Spinner/Spinner";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DownloadData(props) {
  const { isLoaded, capitalizeWords } = props;

  useEffect(() => {
    document.title = "Filter Records ";
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingCompany, setIsLoadingCompany] = useState(true);
  const [dataList, setDataList] = useState([]); //for sunmit response
  const [company, setCompany] = useState([]);
  const [marketer, setMarketer] = useState([]);
  const [games, setGames] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 20;
  const [isFade, setIsFade] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [start_time, setStartTime] = useState("");
  const [end_time, setEndTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [marketerId, setMarketId] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [gamesId, setGamesId] = useState("");
  const [companyIdForMarketer, setCompanyIdForMarketer] = useState("");
  const [loading, setLoading] = useState(false);
  // const [loading, setLoading] = useState(true);
  const [loginUserRole, setLoginUserRole] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [errors, setErrors] = useState({});
  //   console.log("company id", companyId);

  //selected item
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedMarketer, setSelectedMarketer] = useState("");

  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  const navigate = useNavigate();

  //   Do a check if log in user role is company user also call the api marketer
  useEffect(() => {
    const storedUserData = localStorage.getItem("userVASData");

    if (storedUserData) {
      try {
        const parsedData = JSON.parse(storedUserData);
        const id = parsedData.responseDetails?.id;
        const userRoles = parsedData.responseDetails?.roles;

        // console.log("Retrieved user roles:", userRoles);
        // console.log("Retrieved company id:", id);

        if (userRoles) {
          if (userRoles.includes("Admin")) {
            setLoginUserRole("Admin");
          } else if (userRoles.includes("CompanyUser")) {
            setLoginUserRole("CompanyUser");
            if (id) {
              setCompanyIdForMarketer(id); // Set company ID only if CompanyUser
            }
          }
        }
      } catch (error) {
        console.error("Error parsing storedUserData:", error);
      }
    }
  }, []);

  // //Ensure Marketers API runs only when `companyIdForMarketer` is updated
  // useEffect(() => {
  //   if (loginUserRole === "CompanyUser" && companyIdForMarketer) {
  //     console.log("Fetching marketers for company ID:", companyIdForMarketer);
  //     getAllCompanyMarketer(companyIdForMarketer);
  //   }
  // }, [companyIdForMarketer]); // No need to depend on `loginUserRole`

  // currency formatter
  const formatCurrency = (value) =>
    new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(value);

  //   list of company api call
  const getAllCompany = async () => {
    const token = getToken();
    if (!token) {
      Swal.fire({
        title: "Error",
        text: "Please log in first.",
        icon: "error",
      });

      // Clear specific items from local storage
      localStorage.removeItem("companyName");
      localStorage.removeItem("userVASData");

      // Redirect to the login page
      navigate("/login");
      return;
    }

    setIsLoadingCompany(true);
    try {
      const response = await fetch(API_ROUTES.GET_ALL_COMPANY, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        if (response.status === 401) {
          // Show SweetAlert
          Swal.fire({
            title: "Unauthorized",
            text: "Please log in again.",
            icon: "error",
          }).then(() => {
            // Clear data from local storage
            localStorage.removeItem("userVASData");
            localStorage.removeItem("companyName");
            // Redirect the user to the login page
            navigate("/login");
          });
        } else {
          Swal.fire({
            title: "<span className='error_title'>Error</span>",
            html:
              errorMessages[response.status] || `Unexpected error occurred.`,
            icon: "error",
          });
        }

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();
      //console.log("data from api call", responseJSON);
      if (Array.isArray(responseJSON)) {
        // console.log("Response data:", responseJSON);
        const sortedData = responseJSON
          .slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        // setOperatorList(sortedData);
        setCompany(sortedData);
        setCompanyId(sortedData.id);
      } else {
        console.error("Unexpected response format:", responseJSON);
      }
    } catch (error) {
      console.error("Error getting data:", error);
      setCompany([]);
    } finally {
      setIsLoadingCompany(false);
    }
  };

  // useEffect(() => {
  //   if (loginUserRole === "Admin") {
  //     getAllCompany();
  //   }
  // }, [loginUserRole]);

  // combine this useeffect to check user type in other to call marketers api
  useEffect(() => {
    getAllCompany();
  }, []);

  // Function to call API when selectedCompany changes

  useEffect(() => {
    if (selectedMarketer) {
      // setGames(selectedMarketer);
      getAllGames(selectedMarketer);
    }
  }, [selectedMarketer]);

  const getAllCompanyMarketer = async (companyId) => {
    // setDataList([]);
    // console.log("================== i am here===============================");
    const token = getToken();
    if (!token) {
      // console.error("No token found");
      return;
    }

    if (!companyId) {
      // console.error("Company ID is missing.");
      return;
    }

    setLoading(true);

    try {
      const url = `${API_ROUTES.GET_ALL_COMPANY_MARKETER}/${encodeURIComponent(
        companyId
      )}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        if (response.status === 401) {
          Swal.fire({
            title: "Unauthorized",
            text: "Please log in again.",
            icon: "error",
          }).then(() => {
            localStorage.removeItem("userVASData");
            localStorage.removeItem("companyName");
            navigate("/login");
          });
        } else {
          Swal.fire({
            title: "<span className='error_title'>Error</span>",
            html:
              errorMessages[response.status] || `Unexpected error occurred.`,
            icon: "error",
          });
        }

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();
      if (Array.isArray(responseJSON)) {
        const sortedData = responseJSON
          .slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setMarketer(sortedData);
      } else {
        console.error("Unexpected response format:", responseJSON);
      }
    } catch (error) {
      console.error("Error getting data:", error);
      setDataList([]);
    } finally {
      setLoading(false);
    }
  };

  const userData = JSON.parse(localStorage.getItem("userVASData"));
  // console.log("userData", userData?.responseDetails?.id);
  const cpId = userData?.responseDetails?.id;

  const getAllGames = async (selectedMarketer) => {
    const token = getToken();
    if (!token) return;
    // if (!marketer_id) return;

    const data = {
      CompanyId: selectedCompany || cpId,
      MarketerId: selectedMarketer,
    };

    setLoading(true);

    try {
      const response = await fetch(API_ROUTES.GET_GAMES, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        if (response.status === 401) {
          Swal.fire({
            title: "Unauthorized",
            text: "Please log in again.",
            icon: "error",
          }).then((res) => {
            localStorage.removeItem("userVASData");
            localStorage.removeItem("companyName");
            navigate("/login");
          });
        } else {
          Swal.fire({
            title: "<span className='error_title'>Error</span>",
            html:
              errorMessages[response.status] || `Unexpected error occurred.`,
            icon: "error",
          });
        }

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();
      if (Array.isArray(responseJSON)) {
        // console.log("responseJSON.data", responseJSON);

        setGames(responseJSON);
      } else {
        console.error("Unexpected response format:", responseJSON);
      }
    } catch (error) {
      console.error("Error getting data:", error);
      setGames([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") setStartDate(value);
    if (name === "endDate") setEndDate(value);
  };

  function extractAndCombineBreakdowns(data) {
    if (
      !data ||
      !data.marketerBreakdown ||
      data.marketerBreakdown.length === 0
    ) {
      return [];
    }

    const combined = data.marketerBreakdown.flatMap((m) =>
      Array.isArray(m.productDailyBreakdown) ? m.productDailyBreakdown : []
    );

    if (combined.length === 0) return [];

    combined.sort((a, b) => new Date(a.date) - new Date(b.date));

    return combined;
  }

  const validateForm = () => {
    let newErrors = {};

    // Ensure Start Date and End Date are selected
    if (!startDate || !endDate) {
      newErrors.dateRange = "Start Date and End Date are required.";
    } else if (endDate < startDate) {
      newErrors.endDate = "End Date must be later than Start Date.";
    }

    // Ensure Admin selects a company
    if (!selectedCompany || selectedCompany === "") {
      newErrors.companyId = "Please select a company.";
    }

    // // Ensure CompanyUser selects a marketer
    // if (
    //   loginUserRole === "CompanyUser" &&
    //   (!selectedMarketer || selectedMarketer === "")
    // ) {
    //   newErrors.marketer = "Please select a marketer before filtering.";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  // get all total marketers
  const getFilterData = async (formData) => {
    const token = getToken();
    if (!token) {
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(API_ROUTES.PRODUCT_DAILY_BREAKDOWN, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      console.log("api filter response", response);

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        if (response.status === 401) {
          // Show SweetAlert
          Swal.fire({
            title: "Unauthorized",
            text: "Please log in again.",
            icon: "error",
          }).then(() => {
            // Clear data from local storage
            localStorage.removeItem("userVASData");
            localStorage.removeItem("companyName");
            // Redirect the user to the login page
            navigate("/login");
          });
        } else {
          Swal.fire({
            title: "<span className='error_title'>Error</span>",
            html:
              errorMessages[response.status] || `Unexpected error occurred.`,
            icon: "error",
          });
        }

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();
      if (responseJSON) {
        const sortedData = responseJSON;
        console.log(
          "sorted data",
          extractAndCombineBreakdowns(sortedData.data)
        );

        const ReArrangedData = extractAndCombineBreakdowns(sortedData.data);
        setDataList(ReArrangedData);
        // setShowTable(true);
      } else {
        console.error("Unexpected response format:", responseJSON);
      }
      //  console.log("response data from api ", responseJSON);

      // if (response.ok) {
      //   Swal.fire({
      //     title: "Success",
      //     text: "Records fetch successfully.",
      //     icon: "success",
      //   });
      // } else {
      //   Swal.fire({
      //     title: "Error",
      //     text: responseJSON.message || "Unable to fetch  records.",
      //     icon: "error",
      //   });
      // }
    } catch (error) {
      console.error("Error creating marketer:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "An unexpected error occurred.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const formData = {
        startDate: startDate ? new Date(startDate).toISOString() : null, //
        endDate: endDate ? new Date(endDate).toISOString() : null, //
        companyId: companyIdForMarketer || selectedCompany, //
        marketerId: selectedMarketer || null, //
        productId: gamesId || null,
      };
      getFilterData(formData);
      console.log("form data", formData);
    }
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
      format: (row) => new Date(row.date).toLocaleDateString(),
    },
    {
      name: "Product ID",
      selector: (row) => row.productId,
      sortable: true,
    },
    {
      name: "Product Name",
      selector: (row) => row.productName,
      sortable: true,
    },
    {
      name: "Marketer",
      selector: (row) => row.marketerName,
      sortable: true,
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      sortable: true,
    },
    {
      name: "Hits Count",
      selector: (row) => row.hitCount,
      sortable: true,
    },
    {
      name: "Total Subs",
      selector: (row) => row.totalSubscriptions,
      sortable: true,
    },
    {
      name: "Total Unsubs",
      selector: (row) => row.totalUnsubscriptions,
      sortable: true,
    },
    {
      name: "Revenue",
      selector: (row) => row.totalRevenue,
      sortable: true,
    },
    {
      name: "Cost($)",
      selector: (row) => row.totalCost,
      sortable: true,
    },
  ];

  function downloadBreakdownExcel(data = [], fileName = "DailyBreakdown.xlsx") {
    if (!Array.isArray(dataList) || dataList.length === 0) {
      Swal.fire({
        title: "Error",
        text: "No data to download",
        icon: "error",
      });
      return;
    }

    // Define custom headers
    const headers = {
      date: "Date",
      productId: "Product ID",
      productName: "Product Name",
      marketerName: "Marketer",
      unitPrice: "Unit Price",
      hitCount: "Hits Count",
      totalSubscriptions: "Total Subs",
      totalUnsubscriptions: "Total Unsubs",
      totalRevenue: "Revenue",
      totalCost: "Cost($)",
    };

    // Create worksheet with custom headers
    const worksheet = XLSX.utils.json_to_sheet(dataList, { header: Object.keys(headers) });

    // Replace the first row with custom header labels
    XLSX.utils.sheet_add_aoa(worksheet, [Object.values(headers)], { origin: "A1" });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Breakdown");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, fileName);
  }

  return (
    <>
      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body mt--10">
          <div className="container-fluid pl-xs-0 pr-xs-0 pt-xs-0">
            <BreadcrumTop title="Filter Records" />

            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Error Messages */}
                {errors.companyId && (
                  <p className="text-danger">{errors.companyId}</p>
                )}
                {errors.dateRange && (
                  <p className="text-danger">{errors.dateRange}</p>
                )}
                {errors.endDate && (
                  <p className="text-danger">{errors.endDate}</p>
                )}

                <div className="container-fluid d-flex justify-content-end align-items-center mb-4">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="container">
                      <div className="row g-3_ align-items-center">
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <div className="form-label">Start Date</div>
                            <DatePicker
                              selected={startDate ? new Date(startDate) : null}
                              onChange={(date) => {
                                if (date) {
                                  const utcDate = new Date(
                                    Date.UTC(
                                      date.getFullYear(),
                                      date.getMonth(),
                                      date.getDate()
                                    )
                                  );
                                  setStartDate(utcDate);
                                } else {
                                  setStartDate(null);
                                }
                              }}
                              dateFormat="yyyy-MM-dd"
                              className="form-control px-4 rounded-1"
                              style={{ minWidth: "10%" }}
                              placeholderText="Select Start Date"
                            />
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <div className="form-label">End Date</div>
                            <DatePicker
                              selected={endDate ? new Date(endDate) : null}
                              onChange={(date) => {
                                if (date) {
                                  const utcDate = new Date(
                                    Date.UTC(
                                      date.getFullYear(),
                                      date.getMonth(),
                                      date.getDate()
                                    )
                                  );
                                  setEndDate(utcDate);
                                } else {
                                  setEndDate(null);
                                }
                              }}
                              dateFormat="yyyy-MM-dd"
                              className="form-control px-4 rounded-1"
                              placeholderText="Select End Date"
                            />
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <div className="form-label">Company</div>
                            <select
                              className="form-select py-3_ form-control2"
                              value={selectedCompany}
                              onChange={(e) => {
                                setSelectedCompany(e.target.value);
                              }}
                            >
                              <option value="">Select Company</option>
                              {company.map((comp) => (
                                <option key={comp.id} value={comp.id}>
                                  {comp.companyName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6 ">
                          <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-primary"
                            style={{ opacity: loading ? 0.4 : 1 }}
                          >
                            filter
                          </button>
                          <button
                            type="button"
                            disabled={loading}
                            className="btn btn-primary ms-2"
                            style={{ opacity: loading ? 0.4 : 1 }}
                            onClick={downloadBreakdownExcel}
                          >
                            Download
                          </button>
                        </div>
                      </div>

                      {/* Filter Button */}
                      {/* <div className="mt-3">
                        <button type="submit" className="btn btn-primary">
                          Filter
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </form>

            {/* table display */}
            <div style={{ opacity: isFade ? "0.3" : 1 }} className="mt-0">
              {loading && <Spinner loading={loading} />}

              <div className="mt-4">
                {dataList && dataList.length !== 0 ? (
                  <div style={{ opacity: loading ? 0.3 : 1 }}>
                    <DataTable
                      columns={columns}
                      data={dataList}
                      capitalizeWords={capitalizeWords}
                      pagination
                      highlightOnHover
                    />
                  </div>
                ) : (
                  <DataTable
                    // title="Filtered Report"
                    columns={columns}
                    data={[]}
                    capitalizeWords={capitalizeWords}
                    pagination
                    highlightOnHover
                    expandableRows
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
